import React from "react"
import classnames from "classnames"
import { Container, Content, Card } from "AtomicComponents"
import styles from "./ContentCard.less"
import CardYoutubePlayer from "../CardYoutubePlayer/CardYoutubePlayer"
import componentParser from "AtomicUtils/componentParser"

class ContentCard extends React.Component {
  render() {
    const {
      children, heading, description, card, components
    } = this.props
    return (
      <Container styleName='screen'>
        <div className={classnames({
          [styles.ContentCard]: true
        })}>
          <div className={classnames({
            [styles.LeftSide]: true
          })}>
            <h2 className={classnames({
              [styles.LeftSideHeading]: true
            })}>
              {heading}
            </h2>
            <Content xmlString={description} />
            {components && componentParser(components)}
            {!components && children}
          </div>
          <div className={classnames({
            [styles.RightSide]: true
          })}>
            <div>
              {card && card.youtubeId &&
                <CardYoutubePlayer {...card} />
              }
              {card && !card.youtubeId &&
                <Card {...card} />
              }
            </div>
          </div>
        </div>
      </Container>
    )
  }
}

export default ContentCard



// WEBPACK FOOTER //
// ./src/AtomicContainers/ContentCard/ContentCard.jsx